import React from 'react';
import { Button } from './ui/Button';
import { useLanguage } from '../contexts/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-97">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-brand-dark z-0" data-id="element-98">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-gray/20 via-brand-dark to-brand-dark opacity-50" data-id="element-99"></div>
        {/* Abstract grid pattern */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-100"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center flex flex-col items-center" data-id="element-101">
        <span className="inline-block py-1 px-3 border border-brand-accent/30 rounded-full bg-brand-accent/10 text-brand-accent text-sm font-bold tracking-widest uppercase mb-6 animate-fade-in-up" data-id="element-102">
          {t.hero.badge}
        </span>

        <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.9] text-white mb-6 uppercase" data-id="element-103">
          {t.hero.titleLine1}{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-104">
            {t.hero.titleLine2}
          </span>
          <br data-id="element-105" />
          <span className="text-brand-accent" data-id="element-106">{t.hero.titleLine3}</span>
        </h1>

        <p className="text-gray-400 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed" data-id="element-107">
          {t.hero.description}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-108">
          <Button size="lg" withArrow onClick={() => document.getElementById('services')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-109">
            {t.hero.viewPrograms}
          </Button>
          <Button variant="outline" size="lg" onClick={() => document.getElementById('about')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-110">
            {t.hero.meetCoach}
          </Button>
        </div>
      </div>

      {/* Decorative Accent */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-brand-dark to-transparent z-10" data-id="element-111"></div>
    </section>;
}